"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isEmptyString = _interopRequireDefault(require("./isEmptyString"));

var isNotEmptyString = function isNotEmptyString(obj) {
  return !(0, _isEmptyString["default"])(obj);
};

var _default = isNotEmptyString;
exports["default"] = _default;